import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

export const LegalLayout = ({ title, updated, lead, children, testid }) => {
  return (
    <div data-testid={testid} className="bg-stone-50 min-h-screen">
      <Nav />

      <header className="bg-slate-950 text-white pt-32 md:pt-40 pb-16 md:pb-20 relative overflow-hidden grain">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage:
            "radial-gradient(circle at 15% 20%, rgba(52,211,153,0.3), transparent 40%), radial-gradient(circle at 85% 80%, rgba(255,255,255,0.06), transparent 40%)",
        }} />
        <div className="container-narrow relative">
          <Link
            data-testid="legal-back-home"
            to="/"
            className="inline-flex items-center gap-2 overline text-emerald-300 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft size={14} strokeWidth={1.5} /> Back to DreamAxis
          </Link>
          <div className="overline text-slate-400 mb-4">— Legal</div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight">
            {title}
          </h1>
          {lead && (
            <p className="mt-6 text-slate-300 leading-relaxed max-w-2xl">{lead}</p>
          )}
          {updated && (
            <div className="mt-8 overline text-slate-500">Last updated · {updated}</div>
          )}
        </div>
      </header>

      <main className="container-narrow py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <aside className="md:col-span-3">
            <div className="md:sticky md:top-28">
              <div className="overline text-slate-500 mb-4">Legal notices</div>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link
                    data-testid="legal-nav-terms"
                    to="/legal/terms"
                    className="text-slate-700 hover:text-emerald-800 transition-colors"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    data-testid="legal-nav-privacy"
                    to="/legal/privacy"
                    className="text-slate-700 hover:text-emerald-800 transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    data-testid="legal-nav-refunds"
                    to="/legal/refunds"
                    className="text-slate-700 hover:text-emerald-800 transition-colors"
                  >
                    Refund Policy
                  </Link>
                </li>
                <li>
                  <Link
                    data-testid="legal-nav-disclosures"
                    to="/legal/disclosures"
                    className="text-slate-700 hover:text-emerald-800 transition-colors"
                  >
                    Disclosures & Disclaimers
                  </Link>
                </li>
              </ul>
            </div>
          </aside>

          <article className="md:col-span-9 legal-prose">{children}</article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export const Section = ({ number, title, children }) => (
  <section className="mb-12">
    <div className="flex items-baseline gap-4 mb-4">
      <span className="font-mono text-xs text-emerald-800">{number}</span>
      <h2 className="font-serif text-2xl md:text-3xl tracking-tight text-slate-950">
        {title}
      </h2>
    </div>
    <div className="text-slate-700 leading-relaxed space-y-4 text-[15px]">
      {children}
    </div>
  </section>
);

export default LegalLayout;
